import Vue from 'vue';
import App from './App.vue';
import store from './store';
import i18n from './i18n';
import URLS from './URLS';

// Configure Bootstrap
import {
    BadgePlugin,
    ImagePlugin,
    ListGroupPlugin,
    ProgressPlugin,
    CollapsePlugin,
    NavbarPlugin,
    LinkPlugin,
    TooltipPlugin,
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
Vue.use(BadgePlugin);
Vue.use(ImagePlugin);
Vue.use(ListGroupPlugin);
Vue.use(ProgressPlugin);
Vue.use(CollapsePlugin);
Vue.use(NavbarPlugin);
Vue.use(LinkPlugin);
Vue.use(TooltipPlugin);

// Configure Font Awesome Icons
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Register Font Awesome Icons
import { library } from '@fortawesome/fontawesome-svg-core';
import faRegistrator from './faRegistrator';
faRegistrator(library);

// Configure VueScrollTo
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, {
    duration: 500,
    easing: 'ease-in-out',
    offset: -80,
    force: true,
    cancelable: true,
    x: false,
    y: true,
});

// Configure CSS
import './assets/css/global.css';
import './assets/css/theme.css';
import './assets/css/animations.css';
import './config/custom.css';

// Configure global components
import compConfiguration from './compConfiguration';

// Configure AnalyticService
import AnalyticService from '~/services/AnalyticService';
AnalyticService.initialize();

import './registerServiceWorker';
import router from './router';

Vue.config.productionTip = false;
Vue.prototype.$URLS = URLS;

export default new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
